import { IconAngleLeft } from '@iwoca/icons';

import { SIGNUP_STEPS_DIRECT_UK } from '../../constants';
import { useSignupRouterUK } from '../../hooks/useSignupRouter/useSignupRouterUK';
import { useGetStateQuery } from '../../lendingApi/lendingApiQueries';
import { TSignupStepsUK } from '../../types';
import { Button } from '../Button/Button';

const BackToStep = () => {
  const { navigateSignup, currentStep } = useSignupRouterUK();
  const { isStateFetching, isStateLoading } = useGetStateQuery();

  const getPreviousStep = (currentStep: string): TSignupStepsUK => {
    const currentStepIndex = SIGNUP_STEPS_DIRECT_UK.findIndex(
      (step) => step === currentStep,
    );

    if (currentStep === 'check') {
      return 'business';
    }

    if (currentStep === 'documents') {
      return 'applicant';
    }

    if (currentStepIndex > 0) {
      return SIGNUP_STEPS_DIRECT_UK[currentStepIndex - 1];
    }

    return '';
  };

  if (currentStep === 'new') return null;

  const renderButtonText = () => {
    return currentStep === 'documents' ? 'Back to details' : 'Back a step';
  };

  return (
    <Button
      size={currentStep === 'documents' ? 'medium' : 'small'}
      variant="tertiary"
      onClick={() => navigateSignup({ route: getPreviousStep(currentStep) })}
      disabled={isStateFetching || isStateLoading}
    >
      <IconAngleLeft />
      {renderButtonText()}
    </Button>
  );
};

export default BackToStep;
